import { NextPage } from 'next';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { enUS } from 'date-fns/locale';
import { COOKIE_POLICY_DATE, COOKIE_POLICY_DATE_FORMAT } from 'src/common/constants';
import { formatDate } from 'src/common/utils/dateHelpers';
import { loadTranslations } from 'src/common/utils/serverSidePropsHelpers';
import Header from '../../src/common/components/Header';
import Layout from '../../src/common/components/Layout';
import DescriptionMetaTag from '../../src/common/components/MetaTags/DescriptionMetaTag';
import { AuthUserApiResponse } from '../../src/common/types/api/v4/auth/user';
import serverGetUser from '../../src/common/utils/serverGetUser';
import handleApiErrors from '../../src/common/utils/handleApiErrors';
import CookiesPolicy from '../../src/content/Legal/CookiesPolicy';
import withCommonMiddleware from '../../src/common/utils/withCommonMiddleware';

type CookiesPolicyProps = {
  user: Partial<AuthUserApiResponse>;
};

const CookiePolicyPage: NextPage = () => {
  const [t] = useTranslation('legal-cookies-policy');
  const effectiveDate = formatDate(new Date(COOKIE_POLICY_DATE), COOKIE_POLICY_DATE_FORMAT, enUS)
    .toUpperCase();

  return (
    <>
      <Head>
        <title>{t('title')}</title>
      </Head>
      <DescriptionMetaTag
        content={t('meta-description')}
      />
      <Layout>
        <Header />
        <CookiesPolicy effectiveDate={effectiveDate} />
      </Layout>
    </>
  );
};

export const getServerSideProps = handleApiErrors(
  withCommonMiddleware<CookiesPolicyProps>(
    async (context) => ({
      props: {
        user: await serverGetUser(context),
        ...await loadTranslations(
          context.locale,
          [
            'common',
            'legal-cookies-policy',
            'navbar',
            'destination-navigation',
          ],
        ),
      },
    }),
  ),
);

export default CookiePolicyPage;
